import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../components/common/FormikControl";

const Filter = ({ onApply, onClear, initialFilters }) => {
  const initialValues = {
    phase_type: "",
    product: "",
    ...initialFilters,
  };

  const typeOptions = [
    { value: "PMS", label: "PMS" },
    { value: "Commercial", label: "Commercial" },
    { value: "Trial", label: "Trial" },
  ];

  const formOptions = [
    {
      label: "Type",
      type: "checkbox",
      name: "phase_type",
      options: typeOptions,
    },
  ];

  const handleSubmit = (values) => {
    onApply(values);
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  const handleClear = () => {
    formik.resetForm();
    onClear();
  };

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        {formOptions.map((props, key) => (
          <Grid key={key} item xs={12}>
            <FormikControl formik={formik} {...props} />
          </Grid>
        ))}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 2,
            marginTop: "10px",
          }}
        >
          <LoadingButton
            size="large"
            sx={{ borderRadius: "6px" }}
            onClick={handleClear}
            variant="outlined"
          >
            Clear Filter
          </LoadingButton>
          <LoadingButton
            size="large"
            sx={{ borderRadius: "6px" }}
            type="submit"
            variant="contained"
          >
            Apply Filter
          </LoadingButton>
        </Box>
      </form>
    </Box>
  );
};

export default Filter;
